import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ActionCreators from "../../store/actions";

export class CarsCalendarComponent extends PureComponent {
  render() {
    const {
      cellRef,
      carImageRef,
      carDetailRef,
      gridContainedRef,
      daysCount
    } = this.props;

    const parentElementHeight =
      !!gridContainedRef && gridContainedRef.getBoundingClientRect && gridContainedRef.getBoundingClientRect().height;
    const marginLeft =
      !!gridContainedRef && carImageRef.getBoundingClientRect && carDetailRef.getBoundingClientRect &&
      carImageRef.getBoundingClientRect().width +
      carDetailRef.getBoundingClientRect().width;
    const marginTop =
      !!cellRef && cellRef.getBoundingClientRect && cellRef.getBoundingClientRect().height;
    const width =
      daysCount !== 1
        ? !!cellRef && cellRef.getBoundingClientRect &&
          cellRef.getBoundingClientRect().width * daysCount
        : !!cellRef && cellRef.getBoundingClientRect &&
          cellRef.getBoundingClientRect().width * 24;

    return (
      <React.Fragment>
        <div
          className={"grid-container"}
          style={{
            position: "absolute",
            width: width || 0,
            height: (parentElementHeight - marginTop) || 0,
            marginTop: marginTop,
            marginLeft: marginLeft,
            zIndex: -1
          }}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActionCreators, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CarsCalendarComponent);
